import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import axios from "axios";

// @mui material components
import Switch from "@mui/material/Switch";

// Soft UI Dashboard React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";

// Authentication layout components
import CoverLayout from "layouts/authentication/components/CoverLayout";
import AuthenticationLayout from "../components/AuthenticationLayout";
// Images
import model from "assets/images/change.png";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const API_URL = process.env.REACT_APP_API_URL;
const API_TOKEN  = process.env.REACT_APP_API_TOKEN
function ForgotPassword() {
  const navigate = useNavigate();
  const [rememberMe, setRememberMe] = useState(true);
  const handleSetRememberMe = () => setRememberMe(!rememberMe);
  const [userName, setUsername] = useState("");
  const [error,setError]=useState(false)
  const[isDisable,setIsDisable]=useState(false)

  const handleUsernameChange = (event) => {
    setError(false)
    setIsDisable(false)
    setUsername(event.target.value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsDisable(true)
    if (userName === "") {
      console.error("Input fields cannot be empty");
         setError(true);
      return;
    }

    const params = { email: userName };

    try {
      const response = await axios.get(`${API_URL}forgot-password`, {
        params: params,
        headers: {
          "api-token": API_TOKEN,
        },
      });

      if (response.status === 200) {
        // If the request is successful, display the message
        toast.success(response?.data?.message);
      } else {
        toast.error(response?.data?.message)
        console.error("Please enter correct credentials");
      }
    } catch (error) {
      toast.error(error?.response?.data?.message.email ? error?.response?.data?.message.email[0] : error?.response?.data?.message);
      console.error("An error occurred:", error);
    }
  };

  return (
    <AuthenticationLayout
      title="Welcome To Telsim Retailer Portal"
      description="Enter your email to change your password"
      image={model}
    >
           {error && (
          <SoftTypography variant="caption" color="error">
            {" "}
            Please enter valid credentials,input fields cannot be empty
          </SoftTypography>
        )}
       <ToastContainer hideProgressBar={false} position="top-right" autoClose={5000} />
      <SoftBox component="form" role="form" onSubmit={handleSubmit}>
        <SoftBox mb={2}>
          <SoftBox mb={1} ml={0.5}>
            <SoftTypography component="label" variant="caption" fontWeight="bold">
              Enter Your Email
            </SoftTypography>
          </SoftBox>
          <SoftInput
            type="email"
            placeholder="Email"
            value={userName}
            onChange={handleUsernameChange}
          />
        </SoftBox>
        {/* <SoftBox mb={2}>
          <SoftBox mb={1} ml={0.5}>
            <SoftTypography component="label" variant="caption" fontWeight="bold">
              Password
            </SoftTypography>
          </SoftBox>
          <SoftInput type="password" placeholder="Password"  value={password} onChange={handlePasswordChange}/>
        </SoftBox> */}
        {/* <SoftBox display="flex" alignItems="center">
          <Switch checked={rememberMe} onChange={handleSetRememberMe} />
          <SoftTypography
            variant="button"
            fontWeight="regular"
            onClick={handleSetRememberMe}
            sx={{ cursor: "pointer", userSelect: "none" }}
          >
            &nbsp;&nbsp;Remember me
          </SoftTypography>
        </SoftBox> */}
        <SoftBox mt={4} mb={1}>
          <SoftButton variant="gradient" color="primary" fullWidth  disabled={isDisable} onClick={handleSubmit}>
            submit
          </SoftButton>
        </SoftBox>
        {/* <SoftBox mt={3} textAlign="center">
          <SoftTypography variant="button" color="text" fontWeight="regular">
            Don&apos;t  know your password?{" "}
            <SoftTypography
              component={Link}
              to="/authentication/sign-up"
              variant="button"
              color="primary"
              fontWeight="medium"
              textGradient
            >
              Forgot Password
            </SoftTypography>
          </SoftTypography>
        </SoftBox> */}
      </SoftBox>
    </AuthenticationLayout>
  );
}

export default ForgotPassword;